import { render } from "./ProductGridItem.vue?vue&type=template&id=3715adb4&scoped=true"
import script from "./ProductGridItem.vue?vue&type=script&lang=js"
export * from "./ProductGridItem.vue?vue&type=script&lang=js"

import "./ProductGridItem.vue?vue&type=style&index=0&id=3715adb4&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3715adb4"]])

export default __exports__